import { getDailies } from '@/game/GameComponents/PhaserGame/GameInstance';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import WorldExclamationMark from '@/game/prefabs/World/WorldExclamationMark';

export default class Mentor extends Phaser.GameObjects.Container {
  private exclamationMark?: WorldExclamationMark;
  animInterval?: NodeJS.Timeout;
  hasInitialized: boolean = false;

  preUpdate() {
    if (!this.hasInitialized) {
      this.init();
      this.hasInitialized = true;
    }
  }

  init() {
    const hasViewedDailies = getDailies().hasViewedDailyActivities;
    if (!hasViewedDailies) {
      this.exclamationMark = new WorldExclamationMark(
        this.scene,
        this.x,
        this.y - 40,
      );
      this.scene.add.existing(this.exclamationMark);
      this.exclamationMark.initialize();
    }

    this.createAnimations();

    EventsManager.registerEventOn(
      this.scene,
      GAME_EVENTS.DAILY_PANEL_OPENED,
      this.handleDailyPanelOpened,
      this,
    );
    this.scene.events.on('destroy', this.handleSceneDestroyed, this);
    this.scene.events.on('shutdown', this.handleSceneDestroyed, this);
  }

  createAnimations() {
    // Override this in subclasses.
  }

  handleDailyPanelOpened() {
    if (this.exclamationMark) {
      this.exclamationMark.destroy();
    }
  }

  handleSceneDestroyed() {
    clearInterval(this.animInterval);
  }
}
